<div
  class="row badge-wrapper"
  [attr.size]="size"
  [attr.tone]="tone"
  [attr.type]="type"
>
  <rr-icon *ngIf="iconStart" [name]="iconStart"></rr-icon>
  <div class="label-container">
    <ng-content></ng-content>
  </div>
  <rr-icon
    *ngIf="type == 'tag' && iconEnd"
    class="pointer"
    [name]="iconEnd || 'close'"
    (click)="click.emit()"
  ></rr-icon>
</div>
